import { z } from 'zod'

export const NotificationSchema = z.array(
  z.object({
    id: z.number(),
    title: z.string(),
    notificationDate: z.coerce.date(),
    refId: z.string().optional(),
    refNumber: z.string().optional(),
    refType: z.string().optional(),
    url: z.string().optional(),
    byDepartment: z.string(),
    remark: z.string().nullable(),
    isRead: z.boolean(),
    owner: z.object({
      userId: z.number(),
      isRead: z.boolean(),
      readDate: z.coerce.date().optional(),
    }),
  })
)

export const NotificationSearchParamsSchema = z.object({
  dateFrom: z.coerce.date().optional(),
  dateTo: z.coerce.date().optional(),
  refId: z.string().optional(),
})

export type Notification = z.infer<typeof NotificationSchema>
export type NotificationSearchParams = z.infer<
  typeof NotificationSearchParamsSchema
>
